import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=7982db22&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7982db22')) {
      api.createRecord('7982db22', component.options)
    } else {
      api.reload('7982db22', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=7982db22&", function () {
      api.rerender('7982db22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/upload.vue"
export default component.exports